import Vue from 'vue'
import VueRouter from 'vue-router'
import CrowdedTrain from '@/views/CrowdedTrain.vue'
import Login from '@/views/Login.vue'
import CrowdedTrainRegistrationCompleted from '@/views/CrowdedTrainRegistrationCompleted.vue'
import StaffDeviationRegistrationCompleted from '@/views/StaffDeviationRegistrationCompleted'
import StaffDeviation from '@/views/StaffDeviation'
import CrowdedTrainRegistrations from '@/views/monitoring/crowded-train-registrations'
import StaffDeviationRegistrations from '@/views/monitoring/staff-deviation-registrations'
import CleaningRegistrations from '@/views/monitoring/cleaning'
import Cleaning from '@/views/Cleaning'
import Definitions from '@/views/masterdata/definitions'
import Users from '@/views/masterdata/users'
import store from '@/store'
import CleaningRegistrationCompleted from '@/views/CleaningRegistrationCompleted.vue'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    alias: '/crowded-train',
    name: 'REGISTER_CROWDED_TRAIN',
    component: CrowdedTrain,
    meta: {
      authRequired: true,
      accesses: ['REGISTER_CROWDED_TRAIN']
    }
  },
  {
    path: '/cleaning',
    alias: '/cleaning',
    name: 'REGISTER_CLEANING',
    component: Cleaning,
    meta: {
      authRequired: true,
      accesses: ['REGISTER_CLEANING']
    }
  },
  {
    path: '/cleaning-completed',
    alias: '/cleaning-completed',
    name: 'REGISTER_CLEANING',
    component: CleaningRegistrationCompleted,
    meta: {
      authRequired: true,
      accesses: ['REGISTER_CLEANING']
    }
  },
  {
    path: '/crowded-train-registration-completed',
    name: 'CrowdedTrainRegistrationCompleted',
    component: CrowdedTrainRegistrationCompleted,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/staff-deviation',
    name: 'REGISTER_STAFF_DEVIATION',
    component: StaffDeviation,
    meta: {
      authRequired: true,
      accesses: ['REGISTER_STAFF_DEVIATION']
    }
  },
  {
    path: '/staff-deviation-registration-completed',
    name: 'StaffDeviationRegistrationCompleted',
    component: StaffDeviationRegistrationCompleted,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/masterdata/users',
    name: 'MASTERDATA_USER',
    component: Users,
    meta: {
      authRequired: true,
      accesses: ['MASTERDATA_USER']
    }
  },
  {
    path: '/masterdata/definitions',
    name: 'MASTERDATA_DEFINITION',
    component: Definitions,
    meta: {
      authRequired: true,
      accesses: ['MASTERDATA_DEFINITION']
    }
  },
  {
    path: '/monitoring/crowded-train-registrations',
    name: 'MONITORING_CROWDED_TRAIN',
    component: CrowdedTrainRegistrations,
    meta: {
      authRequired: true,
      accesses: ['MONITORING_CROWDED_TRAIN']
    }
  },

  {
    path: '/monitoring/staff-deviation-registrations',
    name: 'MONITORING_STAFF_DEVIATION',
    component: StaffDeviationRegistrations,
    meta: {
      authRequired: true,
      accesses: ['MONITORING_STAFF_DEVIATION']
    }
  },

  {
    path: '/monitoring/cleaning',
    name: 'MONITORING_CLEANING',
    component: CleaningRegistrations,
    meta: {
      authRequired: true,
      accesses: ['MONITORING_CLEANING']
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: async (to, from, next) => {
      const isValidToken = await store.dispatch('user/isValidToken')
      if (isValidToken) {
        return next('/')
      }
      next()
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.name == 'Login') {
    store.commit('app/SET_DRAWER', false)
    return next()
  }
  window.scrollTo(0, 0)
  if (to.meta && to.meta.authRequired) {
    const isValidToken = await store.dispatch('user/isValidToken')
    if (!isValidToken) {
      return store.dispatch('user/logout')
    }
  }
  if (to.meta && to.meta.accesses) {
    if (!store.getters['user/hasAccess'](to.meta.accesses)) {
      return store.dispatch('user/logout')
    }
  }
  next()
})

export default router
